export const isValidNumber = num => {
  if (typeof num === 'string' && num[0] === '0') return false
  // 2147483647 is max signed int
  return !isNaN(num) && num < 2147483647
}
